import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    CANDIDATE_DOB_SET_VALUE,
    CANDIDATE_DOB_SET_VALID,
    GENDER_SET_VALUE,
    SMOKER_SET_VALUE,
    COVER_AMOUNT_SET_VALUE,
    COVER_AMOUNT_SET_VALID,
    YEARS_COVERED_SET_VALUE,
    YEARS_COVERED_SET_VALID,
    DISABILITY_SET_VALUE,
    REINITIALIZE,
    FORM_VALID_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL,
    FORM_INVALID_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL,
    WHICH_FORM_TO_DISPLAY,
    API_PENDING_TRANSITION_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL,
    API_SUCCESS_TRANSITION_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL,
    API_FAILURE_TRANSITION_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL,
    COLLECT_PHYSICAL_IMPAIRMENT_COVER_PREMIUM_DATA,
    CALCULATE_PHYSICAL_IMPAIRMENT_COVER_SUCCESS,
} from '../../actions/roaQuoteTools/physicalImpairmentCoverQuoteTool';

export const initialState = {
    selectedForm: 'form-one',
    formStatus: FORM_STATUS.INVALID,
    physicalImpairmentCoverAmount: null,
    roaCmbObject: {
        __typename: 'Contentstack_call_me_back_ke',
        product: 'Physical Impairment',
        privacy_policy_url: '/privacy-policy/',
        extra_fields:['Email Address']  
    },
    form: {
        candidateDOB: { value: null, error: null, status: null },
        genderValue: { value: 'M', error: null, status: 'valid' },
        smokerValue: { value: 'NS', error: null, status: 'valid' },
        coverAmount: { value: null, error: null, status: null },
        numberOfYearsCovered: { value: null, error: null, status: null },
        disabilityValue: { value: 'No', error: null, status: 'valid' },
    },
};

export default (state = initialState, action) => {
    const mapError = error => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case GENDER_SET_VALUE:
            return updateFormField('genderValue', field => ({
                ...field,
                value: action.value,
            }));

        case CANDIDATE_DOB_SET_VALUE:
            return updateFormField('candidateDOB', field => ({
                ...field,
                value: action.value,
            }));

        case CANDIDATE_DOB_SET_VALID:
            return updateFormField('candidateDOB', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SMOKER_SET_VALUE:
            return updateFormField('smokerValue', field => ({
                ...field,
                value: action.value,
            }));

        case COVER_AMOUNT_SET_VALUE:
            return updateFormField('coverAmount', field => ({
                ...field,
                value: action.value,
            }));

        case COVER_AMOUNT_SET_VALID:
            return updateFormField('coverAmount', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case YEARS_COVERED_SET_VALUE:
            return updateFormField('numberOfYearsCovered', field => ({
                ...field,
                value: action.value,
            }));

        case YEARS_COVERED_SET_VALID:
            return updateFormField('numberOfYearsCovered', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DISABILITY_SET_VALUE:
            return updateFormField('disabilityValue', field => ({
                ...field,
                value: action.value,
            }));

        case WHICH_FORM_TO_DISPLAY:
            return {
                ...state,
                selectedForm: action.value,
            };

        //    API Calls
        case API_PENDING_TRANSITION_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_PHYSICAL_IMPAIRMENT_COVER_QUOTE_TOOL:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        //    Calculate the cover amount
        case COLLECT_PHYSICAL_IMPAIRMENT_COVER_PREMIUM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case CALCULATE_PHYSICAL_IMPAIRMENT_COVER_SUCCESS:
            return { ...state, physicalImpairmentCoverAmount: action.value };

        // Reset the state
        case REINITIALIZE:
            return initialState;
        default:
            return state;
    }
};
